import { render, staticRenderFns } from "./loginPassword.vue?vue&type=template&id=2aa9e13a&scoped=true&"
import script from "./loginPassword.vue?vue&type=script&lang=js&"
export * from "./loginPassword.vue?vue&type=script&lang=js&"
import style0 from "./loginPassword.vue?vue&type=style&index=0&id=2aa9e13a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa9e13a",
  null
  
)

export default component.exports